import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './routes/Home';
import { AppRoute } from './routes/AppRoute';
import { Producer } from './routes/Producer';
import { Admin } from './routes/Admin';
import { Privacy, Terms } from './routes/Legal';
import { OfflineBanner } from './offline-banner/OfflineBanner';
import { LandingPage } from './landing/LandingPage';
import { languages, type Locale } from './landing/i18n/ui';

// Bundles loaded for `/app/:slug/*` paths mount their own <BrowserRouter
// basename={`/app/${slug}`}> via @hook-sdk/template's <AppRoot>. Wrapping
// shell routes in another <BrowserRouter> would create two Router
// contexts and react-router-v6 throws ("You cannot render a <Router>
// inside another <Router>"). Branch at the path level so the bundle
// gets a clean realm.
//
// AppRoute parses `slug` from window.location.pathname directly (since
// it lives outside any Router here).
//
// OfflineBanner mounted at top of both branches so shell pages AND every
// loaded app bundle inherit the global offline indicator (audit Fix #43).

const I18N_LOCALES = (Object.keys(languages) as Locale[]).filter((l) => l !== 'pt-br');

export default function App() {
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/app/')) {
    return (
      <>
        <OfflineBanner />
        <AppRoute />
      </>
    );
  }
  return (
    <>
      <OfflineBanner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {I18N_LOCALES.map((lang) => (
            <Route key={lang} path={`/${lang}`} element={<LandingPage locale={lang} />} />
          ))}
          <Route path="/producer/*" element={<Producer />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="/termos" element={<Terms />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
